import { render, staticRenderFns } from "./register.vue?vue&type=template&id=f6f031de"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserRegisterForm: require('/opt/atlassian/pipelines/agent/build/components/user/UserRegisterForm.vue').default,FormErrors: require('/opt/atlassian/pipelines/agent/build/components/form/FormErrors.vue').default,FormSiteButton: require('/opt/atlassian/pipelines/agent/build/components/form/SiteButton.vue').default,FormWrapper: require('/opt/atlassian/pipelines/agent/build/components/form/FormWrapper.vue').default})
